<template>
  <div class="dialogEnv">
    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '1'">
      <road-form1 :formItem="road1"></road-form1>
    </el-form>

    <el-form  ref="form" label-width="45%" class="formMsg" :disabled="disabled" v-if="parType === '2'">
      <road-form2 :formItem="road2"></road-form2>
    </el-form>
  </div>
</template>

<script>
  import bus from './bus'
  import arrayData from '../assets/javascript/dataProcess'
  import roadForm1 from '../assets/components/form'
  import roadForm2 from '../assets/components/form'

  export default {
    name: "dialogEnv",
    components:{
      roadForm1,
      roadForm2
    },
    data() {
      return {
        /*是否可编辑*/
        disabled:true,
        /*参与方编号*/
        parType:'1',
        /*道路信息数据*/
        roadData:[],
        /*道路信息一*/
        road1:[],
        road2:[]
      }
    },
    methods:{
      /*数据渲染*/
      dataRender(){
        let data = this.roadData;
        if(data.length > 1){
          for(let i = 0;i < this.road1.length;i++){
            for (let key of Object.keys(data[0])) {
              if(key === this.road1[i].name){
                this.road1[i].value = data[0][key];
              }
            }
          }
          for(let i = 0;i < this.road2.length;i++){
            for (let key of Object.keys(data[1])) {
              if(key === this.road2[i].name){
                this.road2[i].value = data[1][key];
              }
            }
          }
        }
      }
    },
    created(){
      this.road1 = arrayData.data2.road;
      this.road2 = arrayData.data2.road_copy;
      /*接收参与方编号*/
      bus.$on("parType",msg=>{
        this.parType = msg;
      });
      /*接收是否可以编辑*/
      bus.$on("change",()=>{
        this.disabled=false;
      });
      /*接收数据*/
      bus.$on("road",msg=>{
        this.roadData = msg;
        this.dataRender();
      });
      /*接收案例编号*/
      bus.$on("caseNumber",msg=>{
        this.road1[0].value = msg;
        this.road2[0].value = msg;
      })
    }
  }
</script>

<style scoped>
  .dialogEnv{
    width: 99%;
    height: 100%;
  }
  .formMsg{
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content:flex-start;
  }

</style>



// WEBPACK FOOTER //
// src/exportData/dialogRoad.vue